import React from 'react';
import './Subtitle.css'

const Subtitle = (props) => {
    return (<>
        <div className= {props.css3} > {props.text} </div>
    </> );
}
 
export default Subtitle;